import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FormType } from '../../enums/formType.enum';
import { PfComponents } from '../../enums/pfComponents';
import { ADN_PLUS } from '../../models';
import { EntityField } from '../../models/EntityField';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { InputBaseComponent } from '../input-base.component';

@Component({
  selector: 'ct-form',
  templateUrl: './ct-form.component.html',
  styleUrls: ['./ct-form.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()',
    '[class]': "'spinner-container kt-portlet'"
  }
})
export class CtFormComponent extends CtrlBaseComponent {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @ViewChild('saveBtn', { read: ViewContainerRef }) saveBtn: ViewContainerRef;
  @ViewChild('updateBtn', { read: ViewContainerRef }) updateBtn: ViewContainerRef;
  @ViewChild('cancelBtn', { read: ViewContainerRef }) cancelBtn: ViewContainerRef;
  @ViewChild('delBtn', { read: ViewContainerRef }) delBtn: ViewContainerRef;

  //ATTRIBUTES
  private valid: boolean;
  private autoDisabled: boolean;
  @Input() bindingAdn: ADN_PLUS;
  @Input() overWriteId: string;
  private formElements: InputBaseComponent[];
  private hasCreate: boolean;
  private hasUpdate: boolean;
  private hasDelete: boolean;
  private hasBinding: boolean = false;
  private cleanFormButton: boolean;
  private disabledBtns: boolean = false;
  private isFilterForm: boolean;
  public dynamicForm: FormGroup;
  private type: FormType;
  public textOrientation: string = "left";
  private showBorders : boolean = true;

  constructor() {
    super();
    this.dynamicForm = new FormGroup({});
  }

  ngAfterViewInit() {
    this.buttonActions();
    this.setChildrenType();
    this.paintChildren(this.getMetaData(), this.target);
    this.updateFormElements();
    this.addButtons();
    console.log(this.getMetaData());
  }

  // EVENTS

  private addButtons(): void {
    if (this.hasCreate || this.hasUpdate) {
      let saveBtn = {
        id: this.getId() + "_btnSave",
        ctType: "CtButton",
        controlProperties: {
          id: this.getId() + "_btnSave",
          buttonText: "Guardar",
          buttonColor: "Primary",
          icon: "fa fa-floppy-o"
        },
        controlActions: [
          {
            "eventName": "onClick",
            "type": 2,
            "action": this.getId() + ".onCreate"
          }
        ],
        models: []
      };

      let updateBtn = {
        id: this.getId() + "_btnUpdate",
        ctType: "CtButton",
        controlProperties: {
          id: this.getId() + "_btnUpdate",
          buttonText: "Guardar cambios",
          buttonColor: "Primary",
          icon: "fa fa-floppy-o"
        },
        controlActions: [
          {
            "eventName": "onClick",
            "type": 2,
            "action": this.getId() + ".onUpdate"
          }
        ],
        models: []
      };

      let cancelBtn = {
        id: this.getId() + "_btnCancel",
        ctType: "CtButton",
        controlProperties: {
          id: this.getId() + "_btnCancel",
          buttonText: "Nuevo",
          buttonColor: "primary",
          icon: "fa fa-pencil-square-o"
        },
        controlActions: [
          {
            "eventName": "onClick",
            "type": 2,
            "action": this.getId() + ".cleanForm",
            "postAction": {
              "eventName": "onClick",
              "type": 2,
              "action": this.getId() + ".onNew"
            }
          }
        ],
        models: []  
      };

      this.paintChildren({ models: [saveBtn] }, this.saveBtn);
      this.paintChildren({ models: [updateBtn] }, this.updateBtn);
      this.paintChildren({ models: [cancelBtn] }, this.cancelBtn);
    }

    if (this.hasDelete) {
      let delBtn = {
        id: this.getId() + "_btnDelete",
        ctType: "CtButton",
        controlProperties: {
          id: this.getId() + "_btnDelete",
          buttonText: "Eliminar",
          buttonColor: "Danger",
          icon: "fa fa-trash"
        },
        controlActions: [
          {
            "eventName": "onClick",
            "type": 2,
            "action": this.getId() + ".onDelete"//NO SE PUEDE LIMPIAR DE UNA VEZ porque se ejecuta aunque de error el borrar
          }
        ],
        models: []
      };

      let delBtnInstance = this.paintService.paintChildren({ models: [delBtn] }, this.compiler, this.delBtn)[0];
      this.childElements.push(delBtnInstance);
    }
  }

  private buttonActions(): void {
    this.hasCreate = this.getEvent('onSubmit') ? true : false;
    this.hasUpdate = this.getEvent('onUpdate') ? true : false;
    this.hasDelete = this.getEvent('onDelete') ? true : false;
  }

  /**
   * It sets the type property of all children of the component to the type property of the parent.
   * @param {any} component - any = this.getMetaData()
   */
  private setChildrenType(component: any = this.getMetaData()): void {
    let acceptedTypes: Set<PfComponents> = new Set<PfComponents>([PfComponents.CtBody,
    PfComponents.CtHeader, PfComponents.CtRow, PfComponents.CtColumn, PfComponents.CtInputText]);
    let firstRow: boolean = true;
    let nextDivided: boolean = false;

    if (this.type === FormType.Default || this.type == null) {
      return;
    }
    component.models.forEach((model, index) => {
      if (acceptedTypes.has(model.ctType)) {
        model.controlProperties['type'] = this.type;
        model.controlProperties['showBorders'] = this.showBorders;

        //
        if (model.ctType === PfComponents.CtRow) {
          if (firstRow) {
            model.controlProperties['isFirstRow'] = true;
            firstRow = false;
          }
          if (index === component.models.length - 1) {
            model.controlProperties['isLastRow'] = true;
          }
          if (nextDivided) {
            model.controlProperties['isDividedTop'] = true;
            nextDivided = false;
          }
          if (!model.controlProperties['isDivided']) {
            nextDivided = true;
          }
        }
        this.setChildrenType(model);
      }
      model.models.forEach((colum, index) => {
        colum.models.forEach((input, index) => {
          if (input.ctType === "CtInputText"||input.ctType === "CtInputNumber"||input.ctType === "CtInputDate") {
            input.controlProperties.textOrientation = this.getTextOrientation();
          }
        })
      })

    })
  }

  public onCreate(): void {
    this.bindFormToAdn();
    let ac = this.getEvent('onSubmit');

    if (ac)
      this.executeAction2(ac);
  }

  public onNew(): void {
    let ac = this.getEvent('onNew');

    if (ac)
      this.executeAction2(ac);
  }

  public onFormChange(): void {
    let ac = this.getEvent('onChange');

    if (ac)
      this.executeAction2(ac);
  }

  public onUpdate(): void {
    this.bindFormToAdn();
    let ac = this.getEvent('onUpdate');

    if (ac)
      this.executeAction2(ac)
  }

  public onDelete(): void {
    let ac = this.getEvent('onDelete');

    if (ac)
      this.executeAction2(ac)
  }

  public onRefresh(): void {
    let ac = this.getEvent('onRefresh');

    if (ac)
      this.executeAction2(ac);
  }

  public cleanForm(): void {
    this.plusAlertService.setUsavedData(false);
    this.hasBinding = false;

    if (this.getAutoDisabled())
      this.disableForm();

    this.setDynamicProperties(this, "bindingAdn", new ADN_PLUS());

    if (this.getFormElements()) {
      this.getFormElements().forEach(el => {
        let onInit = el.getEvent('onInit');
        el.resetToInitState();

        if (onInit)
          this.executeAction2(onInit);
        else if (el.formControl.reset)
          el.formControl.reset(el.getInitValue());
      });
    }

    let ac = this.getEvent('onClear');

    if (ac)
      this.executeAction2(ac);
  }

  public getFormAlignment(): string {
    if (!this.getIsFilterForm()) {
      return '';
    }
    return 'start';
  }

  //PROPERTIES
  getShowBorders(): boolean { return this.showBorders }
  getAutoDisabled(): boolean { return this.autoDisabled }
  getFormElements(): any[] { return this.formElements }
  getValid(): boolean { return this.valid }
  getBindingAdn(): ADN_PLUS { this.bindFormToAdn(); return this.bindingAdn }
  getCleanFormButton(): boolean { return this.cleanFormButton }
  getDisabledBtns(): boolean { return this.disabledBtns }
  getHasBinding(): boolean { return this.hasBinding }
  getHasCreate(): boolean { return this.hasCreate }
  getHasUpdate(): boolean { return this.hasUpdate }
  getHasDelete(): boolean { return this.hasDelete }
  getFormControls() { return this.dynamicForm.controls }
  getForm(): FormGroup { return this.dynamicForm }
  getFormControl(modelId: string): AbstractControl { return this.dynamicForm.get(modelId) }
  getIsFilterForm(): boolean { return this.isFilterForm };
  getType(): FormType { return this.type }
  getTextOrientation(): string { return this.textOrientation }
  setTextOrientation(textOrientation: string) { this.textOrientation = textOrientation }
  setAutoDisabled(autoDisabled: boolean): void { this.autoDisabled = autoDisabled }
  private setFormElements(formElements: any[]): void { this.formElements = formElements }
  private setValid(valid: boolean): void { this.valid = valid }
  private setBindingAdn(bindingAdn: ADN_PLUS): void { this.bindingAdn = bindingAdn }
  setCleanFormButton(cleanFormButton: boolean): void { this.cleanFormButton = cleanFormButton }
  setDisabledBtns(disabledBtns) { this.disabledBtns = disabledBtns }
  setIsFilterForm(isFilterForm: boolean) { this.isFilterForm = isFilterForm }
  setType(type: FormType) { this.type = type }
  setShowBorders(showBorders: boolean): void { this.showBorders = showBorders }




  public updateFormElements(): void {
    try {
      this.dynamicForm.controls = {};
      let formElements = this.getChildsByType<InputBaseComponent>(InputBaseComponent, true);
      this.formElements = [];

      for (let input of formElements) {
        if (input.getCtType() === 'CtLabel' && !input.getModelId())
          continue;

        this.formElements.push(input);
        this.dynamicForm.controls[input.getModelId()] = input.getFormGroup();
        input.setOwnerForm(this);
      }

      if (this.getAutoDisabled())
        this.disableForm();

      this.setBindingAdn(new ADN_PLUS());
      this.bindFormToAdn();
    } catch (e) {
      console.log(e);
    }
  }

  bindAdnToForm(): void {
    let bindingAdn = this.bindingAdn;

    if (!bindingAdn)
      this.cleanForm();

    if (!this.getFormElements())
      return;



    for (let input of this.formElements) {
      let newInputValue = this.utilService.getStringAttribute(input.getModelId(), bindingAdn.ArrayEntities.List);
      //newValues[input.getModelId()] = { [input.getModelId()]: newInputValue };
      input.setValue(newInputValue);
    }


  }

  public bindFormToAdn() {
    let bindingAdn = this.bindingAdn;

    if (!bindingAdn) {
      bindingAdn = new ADN_PLUS();
      this.setBindingAdn(bindingAdn);
    }

    this.formElements.forEach(function (forEl: InputBaseComponent) {
      let property = bindingAdn.ArrayEntities.List.filter(({ Name }) => Name === forEl.getModelId())[0];

      if (!property)
        bindingAdn.ArrayEntities.List.push(new EntityField(forEl.getModelId(), forEl.getValue(), forEl.getInputDataType()));
      else {
        property.Value = forEl.getValue();
        property.Type = forEl.getInputDataType();
      }
    }.bind(this));
  }


  public disableForm(pExceptions: string[] = null, pEnableExceptions: boolean = false): void {
    if (!this.getFormElements()) { return }
    this.getFormElements().forEach((el) => {
      if (pExceptions && pExceptions.indexOf(el.modelId) >= 0) {
        if (pEnableExceptions)
          el.readOnly = false;
      } else
        el.readOnly = true;
    });
  }

  public disableFormPreventUpdate(pExceptions: string[]): void {
    this.disableForm(pExceptions);

    if (!pExceptions || pExceptions.length === 0)
      this.hasUpdate = false;
  }

  public enableForm(pExceptions: string[] = null): void {
    if (!this.getFormElements()) { return }
    this.getFormElements().forEach((el) => {
      if (pExceptions && pExceptions.indexOf(el.modelId) >= 0)
        return;

      el.readOnly = false;
    });
  }

  public enableFormAllowUpdate(pExceptions: string[]): void {
    this.enableForm(pExceptions);

    if (pExceptions && this.getFormElements() && pExceptions.length === this.getFormElements().length)
      this.hasUpdate = false;
    else
      this.hasUpdate = true;
  }
  private mergeAdns(adn: ADN_PLUS): ADN_PLUS {

    let currentAdn = this.bindingAdn;

    if (!currentAdn)
      currentAdn = adn;
    else {
      if (adn) {
        const valores = Object.values(adn);
        try {
          for (let newField of adn.ArrayEntities.List) {
            var field = currentAdn.ArrayEntities.List.find(x => {
              return (x.Name === newField.Name || x.Alias === newField.Alias);
            });

            if (field)
              field.Value = newField.Value;
            else
              currentAdn.ArrayEntities.List.push(newField);
          }
        }
        catch {
          if (valores[0])
            for (let newField of valores[0].ArrayEntities.List) {
              var field = currentAdn.ArrayEntities.List.find(x => {
                return (x.Name === newField.Name || x.Alias === newField.Alias);
              });

              if (field)
                field.Value = newField.Value;
              else
                currentAdn.ArrayEntities.List.push(newField);

            }
        }
      }

    }

    return currentAdn;
  }

  public updateBindingAdn(adn: ADN_PLUS, ignoreUpdateState: boolean = false): void {
    let isNullUpdate = false;

    if (!adn) {
      isNullUpdate = true;
      this.hasBinding = false;
      adn = new ADN_PLUS();

    } else if (!(adn instanceof ADN_PLUS))
      adn = new ADN_PLUS(adn);

    if (!isNullUpdate && !ignoreUpdateState)
      this.hasBinding = true;

    if (this.hasBinding)
      adn = this.mergeAdns(adn);

    this.setBindingAdn(adn);
    this.bindAdnToForm();
  }

  public noUpdateBindingAdn(adn: ADN_PLUS): void {
    this.updateBindingAdn(adn, true);
  }


  getFormElementByModelId(modelId: any) {
    if (!this.getFormElements())
      return;

    for (var element of this.getFormElements()) {
      if (element.modelId === modelId)
        return element;
    }
  }
}

